import { formatearFechaStr } from "../../../utils/dateUtils";

export const ListaFechas = ({ fechas }: { fechas: string[] }) => {
  return (
    <ol>
      {fechas.map((f, index) => (
        <li key={index} className="p-1">
          {formatearFechaStr(f)}
        </li>
      ))}
    </ol>
  );
};
